import { render, staticRenderFns } from "./ExclusionRisk.vue?vue&type=template&id=2cd8d850&scoped=true&"
import script from "./ExclusionRisk.vue?vue&type=script&lang=js&"
export * from "./ExclusionRisk.vue?vue&type=script&lang=js&"
import style0 from "./ExclusionRisk.vue?vue&type=style&index=0&id=2cd8d850&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd8d850",
  null
  
)

export default component.exports